// types
import { MessageType, Message } from '../types/communicateTypes'

/**
 * Retrieve all messages per type (store, personal or generic)
 *
 * @param messageType
 * @param messages
 * @returns
 */
const getAllMessagesPerType = (
  messageType: MessageType,
  messages: Message[]
): Message[] => {
  return messages.filter((msg) => msg.messageType === messageType)
}

/**
 * Retrieve the latest message key per type (store, personal or generic)
 *
 * @param messageType
 * @param Messages
 * @returns message key
 */
const getLatestMessageKeyPerType = (
  messageType: MessageType,
  messages: Message[]
): number => {
  return messages
    .filter((msg) => msg.messageType === messageType)
    .reduce((prev: Message, curr: Message) => {
      if (!prev || curr.essMessageKey > prev.essMessageKey) return curr
      return prev
    }).essMessageKey
}

/**
 * Message/Response title
 *
 * @param type 'E' | 'A'
 * @returns
 */
const messageResponseTitle = (
  type: 'E' | 'A'
): { message: string; response: string } => {
  return {
    message: type === 'E' ? 'You' : 'Admin',
    response: type === 'E' ? 'Admin' : 'You'
  }
}

/**
 * Check if the message is belong message types
 *
 * @param type
 * @returns
 */
const isMessageType = (type: MessageType): boolean => {
  return type === 'S' || type === 'P' || type === 'G'
}

export {
  getAllMessagesPerType,
  getLatestMessageKeyPerType,
  messageResponseTitle,
  isMessageType
}
